import { Link } from "react-router-dom";
import { buttonClassName, EmptyState, PageHeader } from "@evolua/ui";

export function NotFoundPage() {
  return (
    <>
      <PageHeader
        title="Página não encontrada"
        lead="O endereço não existe ou foi movido. Confira o menu ou volte ao início."
      />
      <EmptyState
        title="Endereço inválido"
        description="Não encontramos este caminho no portal."
        action={
          <Link to="/" className={buttonClassName({ variant: "primary" })}>
            Ir para o início
          </Link>
        }
      />
    </>
  );
}
